export default {
    en: {
        info: {
            title: "New Product",
            content: 'Please, fill up the form with your product details.',
            button: "Products",
        },
        form: {
            name: { label: "Product Name", placeholder: "Channel" },
            code: { label: "Design Code", placeholder: "1049" },
            quality: { label: "Quality", placeholder: "Premium" },
            brand: { label: "Brand", placeholder: "Diamond" },
            category: { label: "Category", options: { carpet: 'Carpet', hallway: "Hallway Runner", mats: "Door Mats", others: "Others" } },
            color: { label: "Color", placeholder: "Green" },
            steps: { next: "Next", back: "Back" },
            width: { label: "Width (meter)", placeholder: "2" },
            length: { label: "Length (meter)", placeholder: "5" },
            squareMeter: { label: "Square Meter", placeholder: "10" },
            quantity: { label: "Quantity", placeholder: "10" },
            basePrice: { label: "Base/Import Price", placeholder: "$2" },
            salePrice: { label: "Min/Sale Price", placeholder: "$4" },
            alertNumber: { label: "Alert if less than #", placeholder: "Alert number" },
            info: { label: "Product details", placeholder: "Type Useful Information..." },
            button: "Create Product"
        },
        popup: {
            title: "has been created",
            button: "View"
        },
        edit: {
            button: 'Update Product',
            alert: { title: "If you want to edit go to", button: "Edit the product" }
        }
    },
    uz: {
        info: {
            title: "Yangi mahsulot",
            content: "Iltimos, formasini mahsulot ma'lumotlari bilan to'ldiring.",
            button: "Mahsulotlar",
        },
        form: {
            name: { label: "Mahsulot nomi", placeholder: "Channel" },
            code: { label: "Dizayn kodi", placeholder: "1049" },
            quality: { label: "Sifati", placeholder: "Premium" },
            brand: { label: "Brend(Ishlab chiqaruvchi)", placeholder: "Diamond" },
            category: { label: "Kategoriya", options: { carpet: 'Gilam', hallway: "Yo'lakcha", mats: "Eshik Matlari", others: "Boshqalar" } },
            color: { label: "Rangi", placeholder: "Yashil" },
            steps: { next: "Keyingi", back: "Oldingi" },
            width: { label: "Kenglik (metrda)", placeholder: "2" },
            length: { label: "Uzunligi (metrda)", placeholder: "5" },
            squareMeter: { label: "Kvadrat metr", placeholder: "10" },
            quantity: { label: "Miqdori", placeholder: "10" },
            basePrice: { label: "Tan/Import narxi", placeholder: "$2" },
            salePrice: { label: "Minimal/Sotish narxi", placeholder: "$4" },
            alertNumber: { label: "Ogohlantirish", placeholder: "Ogohlantirish raqami" },
            info: { label: "Mahsulot tafsilotlar", placeholder: "Foydali ma'lumotni kiriting..." },
            button: "Mahsulot Yaratish"
        },
        popup: {
            title: "muvaffaqiyatli yaratildi",
            button: "Ko'rinish"
        },
        edit: {
            button: 'Update Product',
            alert: { title: "Agar siz ma'lumotni o'zgartirishni xohlasangiz", button: "Mahsulotni tahrirlang" }
        },

    },
    ru: {
        info: {
            title: "Новый продукт",
            content: "Пожалуйста, заполните форму с информацией о вашем продукте.",
            button: "Товары",
        },
        form: {
            name: { label: "Название продукта", placeholder: "Channel" },
            code: { label: "Код дизайна", placeholder: "1049" },
            quality: { label: "Качество", placeholder: "Premium" },
            brand: { label: "Марка", placeholder: "Diamond" },
            category: { label: "Категория", options: { carpet: 'Ковер', hallway: "Дорожка", mats: "Дверные коврики", others: "Другие" } },
            color: { label: "Цвет", placeholder: "Зеленый" },
            steps: { next: "Следующий", back: "Назад" },
            width: { label: "Ширина (на метры)", placeholder: "2" },
            length: { label: "Длина (на метры)", placeholder: "5" },
            squareMeter: { label: "Квадратный метр", placeholder: "10" },
            quantity: { label: "Количество", placeholder: "10" },
            basePrice: { label: "Базовая цена", placeholder: "$2" },
            salePrice: { label: "Цена продажа", placeholder: "$4" },
            alertNumber: { label: "Сообщите, если меньше", placeholder: "Номер уведомления" },
            info: { label: "Информация о продукте", placeholder: "Введите информация..." },
            button: "Создать продукт"
        },
        popup: {
            title: "успешно создан",
            button: "Посмотреть"
        },
        edit: {
            button: 'Update Product',
            alert: { title: "Если вы хотите редактировать, перейдите в", button: "Изменить продукт" }
        }
    },
}